import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Auth0Lock } from 'auth0-lock';
import _ from 'lodash';

import { AuthenticationAPI } from '../../lib/api';

import config from '../../lib/config';
import { orgs } from '../../lib/orgs';
import { auth } from '../../lib/auth';
import { settings } from '../../lib/settings';

import logo from '../../images/logo_login.svg';
import background from '../../images/bg_01@2x.png';

const API = {
  auth: new AuthenticationAPI(),
};

class LoginView extends Component {
  state = { error: null };

  componentDidMount() {
    const { query = {} } = this.props;
    this.lock = new Auth0Lock(
      config.auth.auth0.client_id,
      config.auth.auth0.domain,
      {
        container: 'login-root',
        auth: {
          responseType: 'id_token',
          audience: config.auth.auth0.audience,
          params: {
            scope: 'openid profile',
          },
        },
        autoclose: true,
        languageDictionary: {
          forgotPasswordTitle: 'Set or Reset your password',
          forgotPasswordAction: 'Set or Reset Password',
          forgotPasswordInstructions: 'Please enter your email address. We will send you an email to set or reset your password.',
        },
        theme: {
          logo: 'https://blumira.com/img/blumira-logo-icon.png',
        },
      }
    );

    this.lock.on('authenticated', this.onAuthenticated);
    this.lock.on('authorization_error', this.onAuthError);

    if (query.logout === 'true') {
      this.lock.logout();
    }

    this.lock.show();
  }

  onAuthError = (error) => {
    this.lock.hide();
    this.lock.show({
      flashMessage: {
        type: 'error',
        text: error.errorDescription || error.description,
      },
    });
  };

  onAuthenticated = (authResult) => {
    this.setState({ error: null });
    auth.authenticated = true;
    localStorage.setItem('accessToken', authResult.accessToken);
    localStorage.setItem('idToken', authResult.idToken);
    localStorage.setItem('expiresIn', authResult.expiresIn);
    localStorage.setItem('idTokenPayload', JSON.stringify(authResult.idTokenPayload));
    auth.token = authResult.idToken;
    auth.payload = authResult.idTokenPayload;
    auth.setHeaders();
    settings.clear();
    orgs.clear();
    API.auth.login().then((resp) => {
      auth.login(_.get(resp, 'data.data', {}));
      this.props.routeToPage({ orgId: 'default', toplevel: 'dashboard' });
    }).catch((resp) => {
      this.setState({
        error: {
          message: resp.detail || resp.message || resp.error,
        },
      });
      console.error('Unable to log in');
    });
  };

  render() {
    const error = this.state.error || this.props.error;
    return (
      <div
        className='h-100 w-100 d-flex align-items-center login'
        style={{
          backgroundImage: `url(${background})`,
          backgroundSize: 'cover',
          overflow: 'auto',
        }}
      >
        <div
          className='w-100'
        >
          <div className='row mx-auto align-items-center'>
            <div
              className='col align-items-center mx-auto'
              style={{
                textAlign: 'center',
                maxWidth: '60%',
                minWidth: '30%',
                paddingTop: '80px',
              }}
            >
              <img
                className='mx-auto'
                style={{
                  width: '100%',
                  minWidth: '200px',
                  maxWidth: '300px',
                }}
                src={logo}
                alt='Logo'
                title='Blumira'
              />
              <h3
                style={{
                  margin: '80px 0px 0px',
                  fontSize: '30px',
                  color: '#FFF',
                  fontWeight: 300,
                }}
              >
                Welcome.
              </h3>
              <p
                style={{
                  fontSize: '18px',
                  color: '#FFF',
                  fontWeight: 300,
                  margin: '24px 0px 40px',
                }}
              >
                Please login to your account.

              </p>
            </div>
          </div>
          <div className='row mx-auto align-items-center'>
            <form
              className='mx-auto'
              onSubmit={(e) => { e.preventDefault(); }}
              style={{ paddingBottom: '40px' }}
            >
              <div
                className='col align-items-center'
                style={{ textAlign: 'center', boxSizing: 'border-box', padding: '0px' }}
              >
                {error && error.message &&
                  <div className='alert alert-danger' role='alert'>
                    {error.message}
                  </div>
                }
                <div className='form-group' style={{ marginTop: '32px' }}>
                  <div
                    id='login-root'
                  />
                </div>
                <div style={{
                  fontSize: '10px',
                  color: '#FFF',
                  marginTop: '20px',
                }}
                >
                  <p>
                    <small><small> build: {config.image_tag} </small></small>
                  </p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

LoginView.propTypes = {
  query: PropTypes.shape({ logout: PropTypes.string }),
  error: PropTypes.shape({ message: PropTypes.string }),
  routeToPage: PropTypes.func,
};

LoginView.defaultProps = {
  query: {
    logout: 'false',
  },
  error: null,
  routeToPage: () => {},
};

export default LoginView;



// WEBPACK FOOTER //
// ./src/views/Login/LoginView.js